<script>
import Vue from 'vue';
import DirectiveTooltip from './DirectiveTooltip.vue';

export default {
  name: 'Tooltip',
  props: {
    placement: {
      type: String,
      default: 'top'
    },
    pointer: {
      type: String,
      default: 'center'
    },
    popperClass: {
      type: String,
      default: ''
    },
    manual: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false,
    }
  },
  beforeDestroy() {
    this.destroyTooltip()
  },
  render(createElement) {
    if (this.$slots.default && this.$slots.default.length > 0) {
      const defaultSlot = this.$slots.default[0]

      if (defaultSlot.tag) {
        // 合并事件，保留已有的事件处理
        let on = defaultSlot.data?.on || {}
        if (!this.manual) {
          on = {
            ...on,
            mouseenter: (event) => {
              if (this.disable) return
              this.createTooltip(event)
              if (defaultSlot.data?.on?.mouseenter) {
                defaultSlot.data.on.mouseenter(event)
              }
            },
            mouseleave: (event) => {
              this.destroyTooltip()
              if (defaultSlot.data?.on?.mouseleave) {
                defaultSlot.data.on.mouseleave(event)
              }
            }
          };
        }
        
        // 返回元素并绑定事件
        return createElement(defaultSlot.tag, { ...defaultSlot.data, on }, defaultSlot.children)
      }
    }

    return createElement('div', '缺少根元素')
  },
  methods: {
    createTooltip(event) {
      if (this.tooltipInstance) {
        this.destroyTooltip()
      }
      const TooltipConstructor = Vue.extend(DirectiveTooltip)
      const rect = event.target.getBoundingClientRect()
      const targetRect = {
        x: rect.x,
        y: rect.y,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left
      };
      this.tooltipInstance = new TooltipConstructor({
        propsData: {
          show: true,
          targetRect: targetRect,
          placement: this.placement,
          pointer: this.pointer,
          popperClass: this.popperClass
        }
      })

      const contentSlot = this.$scopedSlots.content ? this.$scopedSlots.content() : []
      this.tooltipInstance.$slots.default = contentSlot

      this.tooltipInstance.$mount()
      document.body.appendChild(this.tooltipInstance.$el)
    },
    destroyTooltip() {
      if (this.tooltipInstance) {
        this.tooltipInstance.$destroy()
        if (this.tooltipInstance.$el.parentNode) {
          this.tooltipInstance.$el.parentNode.removeChild(this.tooltipInstance.$el)
        }
        this.tooltipInstance = null
      }
    }
  },
  watch: {
    'show': {
      handler: function(v) {
        if (this.manual) {
          if (v) {
            if (this.disable) return
            this.$nextTick(() => {
              this.createTooltip({target: this.$el})
            })
          } else {
            this.destroyTooltip()
          }
        }
      },
      immediate: true,
    },
    manual(v) {
      if (!v) {
        this.destroyTooltip()
      }
    }
  }
};
</script>
